import { render, staticRenderFns } from "./fabricaRacaoForm.vue?vue&type=template&id=5380b954&scoped=true&"
import script from "./fabricaRacaoForm.vue?vue&type=script&lang=js&"
export * from "./fabricaRacaoForm.vue?vue&type=script&lang=js&"
import style0 from "./fabricaRacaoForm.vue?vue&type=style&index=0&id=5380b954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5380b954",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VForm,VLayout,VTextField})
